import React from "react";
import SquareBooking from '../components/SquareBooking';
import HeaderSpacer from '../components/HeaderSpacer';

function Book() {
  return (
    <div>
      <HeaderSpacer/>
      <SquareBooking/>
    </div>
  );
}

export default Book;
